import React from "react";
import ContactCard from "../ContactCard/ContactCard";
import ContactForm from "../ContactForm/ContactForm";
import { useTranslation } from "react-i18next";

const ContactUsSection = ({
  cardImageSrc,
  formTextarea,
  formButton,
  customClass,
  key,
}) => {
  const { t } = useTranslation();
  return (
    <div
      key={key || ""}
      className={`px-[16px] sm:px-[40px] md:px-[50px] lg:px-0 lg:container mt-[100px] ${customClass}`}
    >
      <div className="flex flex-col gap-10 lg:flex-row lg:gap-4">
        <div className="w-full flex flex-col justify-start items-start lg:pl-[2px]">
          <h2 className="text-[#2B2D42] text-left self-start text-[28px] font-bold pb-1">
            {t("common:landing.contactUsSection_title")}
          </h2>
          <p className="text-base text-[#2B2D42] text-left md:w-[95%]">
            {t("common:landing.contactUsSection_subtitle")}
          </p>

          <ContactForm formTextarea={formTextarea} formButton={formButton} />
        </div>

        <div className="w-full lg:w-1/3 flex justify-center items-center lg:pl-5 lg:pr-[6px]">
          <ContactCard imageSrc={cardImageSrc} />
        </div>
      </div>
    </div>
  );
};

export default ContactUsSection;
